import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import * as echarts from 'echarts'
import VueCookies from 'vue-cookies'
import axios from 'axios';


Vue.config.productionTip = false
Vue.use(VueCookies)

Vue.prototype.$axios = axios;

new Vue({
    render: (h: (arg0: typeof App) => any) => h(App),
    router
}).$mount('#app')


Vue.prototype.$echarts = echarts